export default __webpack_public_path__ + "static/media/img-09.138781ba.png";